import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

export function useGoToGame(clubId: string) {
  const navigate = useNavigate();
  return useCallback(
    (gameId: string, tournamentId: string) => {
      navigate({
        to: '/club/$clubId/tournament/$tournamentId/game/$gameId',
        params: { clubId, tournamentId, gameId },
        from: '/',
      });
    },
    [navigate, clubId],
  );
}
